import { getJson, postJson } from "../api/client";

/** A role, ranked viewer < operator < admin. */
export type AuthRole = "viewer" | "operator" | "admin";

/** Public user shape returned by the auth endpoints. */
export interface AuthUser {
	id: string;
	email: string;
	role: AuthRole;
}

/** Session payload returned by `POST /auth/login`. */
export interface LoginResult {
	token: string;
	user: AuthUser;
	/** Unix seconds the session token expires. */
	expiresAt: number;
}

/** Exchange email + password for a session token. */
export function login(email: string, password: string): Promise<LoginResult> {
	return postJson<LoginResult>("/auth/login", { email, password });
}

/** A user account as returned by the admin list endpoint. */
export interface AdminUser extends AuthUser {
	/** ISO-8601 UTC timestamp the account was created. */
	createdAt?: string;
}

/** List every account (admin only — `GET /auth/users`). */
export function listUsers(): Promise<AdminUser[]> {
	return getJson<{ users: AdminUser[] }>("/auth/users").then((r) => r.users);
}

/** Fields needed to provision a new account. */
export interface CreateUserInput {
	email: string;
	password: string;
	role: AuthRole;
}

/** Provision a new account (admin only — `POST /auth/users`). */
export function createUser(input: CreateUserInput): Promise<AuthUser> {
	return postJson<AuthUser>("/auth/users", input);
}
